module.exports = __webpack_public_path__ + "img/stop-create.2aa4e06b.png";